"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isHex_1 = __importDefault(require("./isHex"));

var keccak256_1 = __importDefault(require("./keccak256"));

var removeHexPrefix_1 = __importDefault(require("./removeHexPrefix"));

var hashPersonalMessage = function hashPersonalMessage(message) {
  if (typeof message === 'string') {
    if (isHex_1.default(message, {
      requirePrefix: true
    })) {
      message = Buffer.from(removeHexPrefix_1.default(message), 'hex');
    } else {
      message = Buffer.from(message);
    }
  }

  var prefix = Buffer.from("\x19Ethereum Signed Message:\n" + message.length.toString(), 'utf8');
  return keccak256_1.default(Buffer.concat([prefix, message]));
};

exports.default = hashPersonalMessage;